import { fetchHolidays } from "./api";

const initDB = () => {
    return new Promise((resolve, reject) => {
        const request = indexedDB.open('HolidaysCache', 1);

        request.onupgradeneeded = e => {
            const db = e.target.result;
            db.createObjectStore('holidays', { keyPath: 'year' });
        };

        request.onsuccess = e => resolve(e.target.result);
        request.onerror = e => reject(e.target.error);
    });
};

const cacheHolidays = async (year, holidays) => {
    const db = await initDB();
    const transaction = db.transaction('holidays', 'readwrite');
    const store = transaction.objectStore('holidays');
    store.put({ year, holidays });
    return transaction.complete;
};

const getCachedHolidays = async (year) => {
    const db = await initDB();
    return new Promise((resolve, reject) => {
        const transaction = db.transaction('holidays', 'readonly');
        const store = transaction.objectStore('holidays');
        const request = store.get(Number(year));

        request.onsuccess = () => resolve(request.result?.holidays || null);
        request.onerror = () => reject(request.error);
    });
};

const getHolidays = async (year) => {
    if (!year) {
        return null;
    }

    const cached = await getCachedHolidays(year);
    if (cached) return cached;

    const holidays = await fetchHolidays(year);

    await cacheHolidays(Number(year), holidays);
    return holidays;
};

export { getHolidays };